export default __webpack_public_path__ + "static/media/Vaccines_south_vancouver_clinic.e2c5ad87.pdf";